<template>
  <DashboardHeader title="E-learning Dashboard">
    <v-content>
      <v-layout row wrap>
        <v-flex xs12 md4 v-for="grade in grades" :key="grade.id" class="rounded-corners">
          <v-card class="mx-auto mb-4 rounded-corners" max-width="300" elevation="22">
            <v-img
              class="white--text align-end rounded-corners"
              height="200px"
              :src="getApiUrl+'/images/grade_cover_images/'+grade.cover_img"
            >
              <v-card-title></v-card-title>
            </v-img>

            <v-card-subtitle class="pb-0">{{grade.name}}</v-card-subtitle>

            <v-card-text class="text--primary">
              <div></div>
              <div></div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="var(--theme-color)"
                text
                :to="{name:'subjects',params:{gradeId:grade.grade_id,gradeName:grade.name}}"
              >Explore Subjects</v-btn>

              <!--v-btn
                    color="var(--theme-color)"
                    text
                  >
                    Explore
              </v-btn-->
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-content>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader";
import axios from "@/plugins/axios";
import { mapGetters } from "vuex";

export default {
  components: {
    DashboardHeader
  },
  computed: mapGetters(["getAccessToken", "getCurrentUser", "getApiUrl"]),
  data() {
    return {
      grades: []
    };
  },
  mounted() {
    this.$store.commit("setLoader", true);

    axios.getData("/auth/grades", this.getAccessToken).then(response => {
      this.grades = response;
      this.$store.commit("setLoader", false);
    });
  }
};
</script>

<style>
.rounded-card {
  border-radius: 30px;
}
</style>
